<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-trophy`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M35.012 4c1.552 0 2.755.795 3.431 2H44a2 2 0 012 2v8.91c0 6.986-3.268 12.095-9.167 12.96-2.291 3.785-6.18 6.442-10.842 7.109v2.577h2.567A4.444 4.444 0 0133.002 44H15.057a4.444 4.444 0 014.445-4.444H22v-2.577c-4.658-.666-8.517-3.321-10.785-7.102C5.285 29.032 2 23.915 2 16.91V8a2 2 0 012-2h5.607c.658-1.205 1.838-2 3.39-2h22.015zm0 4.018H12.996v13.76c0 6.136 4.872 11.276 11.008 11.276 6.137 0 11.008-5.14 11.008-11.276V8.018zM9.017 10.02H6.029v7.08c0 3.658 1.192 6.217 3.236 7.527a16.373 16.373 0 01-.247-2.85L9.017 10.02zm32.955-.023l-2.922-.001v11.783c0 .955-.081 1.888-.24 2.79 1.999-1.334 3.162-3.89 3.162-7.502v-7.07z"/></svg>
</template>
<script>

export default {
  name: 'IconTrophy',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
